// @flow
import actionTypes from '../../actionTypes';
import { fetch } from '../../../api';
import { getAsyncHashImage } from './uploadImage';
import formatComposeData from './formatComposeData';

type ComposeData = {
  body: string,
  group: Group,
  isPrivate: boolean,
  isUploading: any,
  postTypeId: number,
  title: string,
  author: User,
}

export function failSendingPostAction(id: IdType, message: string, error: any) {
  return {
    type: actionTypes.POST_SEND_FAILURE,
    data: { posts: [{ id, hasFailed: true }] },
    error,
    isAsynchronous: true,
    alert: {
      type: actionTypes.POST_SEND_FAILURE,
      alertType: 'warning',
      message,
      postId: id,
    },
  };
}

export function succeedSendingPostAction(oldPost: Post, post: Post) {
  const newPost: Post = { ...oldPost, ...post, hasFailed: false, isTemporary: false };

  return {
    type: actionTypes.POST_SEND_SUCCESS,
    data: { posts: [newPost] },
    dataToDelete: { posts: [oldPost] },
    isAsynchronous: true,
  };
}

export default (data: ComposeData) => {
  return async (dispatch: Dispatch, getState: GetState) => {
    const { localData, queryData, commonData } = formatComposeData(data, getState());
    if (!!data.id && !!localData.isTemporary && !localData.hasFailed) return;

    dispatch({
      type: actionTypes.POST_SEND,
      data: { posts: [{ ...commonData, ...localData }] },
    });

    let post;
    try {
      const postImageHash = await getAsyncHashImage(data.isUploading, localData.id, dispatch) || undefined;
      const body = { ...commonData, ...queryData, postImageHash };

      const result = await fetch('blog', { method: 'POST', body: JSON.stringify(body) });
      post = result.payload.post;
    } catch (error) {
      return dispatch(failSendingPostAction(localData, commonData.title, error));
    }

    const state = getState();
    return dispatch(succeedSendingPostAction(state.data.posts[localData.id], post));
  };
};



// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/posts/compose.js